module.exports = __webpack_public_path__ + "rosacea_5_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/rosacea_5_before_tn.jpg
// module id = 1454
// module chunks = 0